import {
  Dialog,
  DialogHeader,
  DialogBody,
  TextLink,
  DialogActions,
  Button,
  Text,
} from '@frontend/ui-library';
import links from '../../constants/links';

export interface PaymentGoBackModalProps {
  loading: boolean;
  isOffRamp: boolean;
  onRestartPaymentClick: () => void;
  onRequestClose: () => void;
}

export default function PaymentGoBackModal({
  loading,
  isOffRamp,
  onRestartPaymentClick,
  onRequestClose,
}: PaymentGoBackModalProps): JSX.Element {
  const description = isOffRamp
    ? 'Going back to select another currency or method will restart your off ramp process.'
    : 'Going back to select another payment currency or method will restart your payment process';

  return (
    <Dialog onRequestClose={onRequestClose}>
      <DialogHeader description={description}>
        {isOffRamp ? 'Restart process?' : 'Restart payment process?'}
      </DialogHeader>
      <DialogBody>
        <Text
          size="small"
          color="neutral-800"
          data-test="refundConfirmationText"
        >
          You will receive an email for any transactions <br /> that meet{' '}
          <TextLink
            size="inherit"
            href={links.support.REFUND_POLICY}
            target="_blank"
            rel="noopener noreferrer"
          >
            our refund policy.
          </TextLink>
        </Text>
      </DialogBody>
      <DialogActions>
        <Button
          onClick={onRequestClose}
          size="medium"
          type="button"
          variant="secondary"
        >
          Stay
        </Button>
        <Button
          size="medium"
          type="button"
          variant="danger"
          loading={loading}
          onClick={onRestartPaymentClick}
        >
          Restart
        </Button>
      </DialogActions>
    </Dialog>
  );
}
